import { useTranslation } from 'react-i18next';
import styles from './BetaPill.module.css';

/** "BETA" marker for a feature still being proven on real sites — MockPill's label in the primary tint.
    Visual only: hidden from assistive tech so it doesn't run into the host control's name. */
export function BetaPill() {
  const { t } = useTranslation();
  return <span className={styles.beta} aria-hidden="true">{t('common.beta')}</span>;
}
